import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import Footer from "@/components/Footer";

/**
 * Shared shell for static informational pages (Privacy, Terms, Security, About, Contact).
 * Provides consistent header + footer + typography.
 */
export default function StaticPage({ eyebrow, title, updatedAt, children }) {
  return (
    <div className="min-h-screen bg-[#FAF7F0] text-[#252525] flex flex-col">
      <header className="border-b border-[#E5E0D8] bg-[#FAF7F0]/95 backdrop-blur sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-6 sm:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="static-header-home">
            <span className="w-8 h-8 rounded-2xl bg-[#183D36] text-[#F4B183] flex items-center justify-center">
              <Sparkles size={16} strokeWidth={2} />
            </span>
            <span className="font-heading text-lg font-semibold text-[#183D36]">NextVisit</span>
          </Link>
          <Link to="/" className="text-xs text-[#4A4A4A] hover:text-[#183D36] inline-flex items-center gap-1.5 font-accent uppercase tracking-widest">
            <ArrowLeft size={12} /> Back to home
          </Link>
        </div>
      </header>
      <main className="flex-1 py-16 sm:py-24">
        <div className="max-w-3xl mx-auto px-6 sm:px-10">
          {eyebrow && <div className="overline text-[#F4B183] mb-3">{eyebrow}</div>}
          <h1 className="font-heading text-4xl sm:text-5xl text-[#183D36] mb-3" data-testid="static-page-title">{title}</h1>
          {updatedAt && <p className="text-xs font-accent uppercase tracking-widest text-[#4A4A4A] mb-10">Last updated {updatedAt}</p>}
          <div className="static-content space-y-6 leading-relaxed text-[#252525]">
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
